









































import {Component} from "vue-property-decorator";
import {CustomerStore} from "@/modules/customers/store";
import {CustomerParams} from "@/modules/customers/params";
import CommonStatusLabel from "@/shared/components/CommonStatusLabel/index.vue";
import CustomerTableAction from "@/modules/customers/List/components/TableAction.vue";
import CustomerSearch from "@/modules/customers/List/components/Search.vue";
import {PAGE_SIZE_OPTIONS} from "@/shared/constant";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import TooltipLabel from "@/shared/components/TooltipLabel/TooltipLabel.vue";

@Component({
    name: "CustomerList",
    components: {TooltipLabel, CustomerTableAction, CustomerSearch, CommonStatusLabel}
})
export default class extends mixins(CommonMixin) {
    columns = [
        {
            title: "Thao tác",
            dataIndex: "rowGuid",
            key: "rowGuid",
            scopedSlots: {customRender: 'action'},
            width: 100
        },
        {
            title: "Mã khách hàng",
            dataIndex: "customerCode",
            key: "customerCode",
            width: 120,
            ellipsis: true
        },
        {
            title: "Tài khoản",
            dataIndex: "account.username",
            key: "username",
            width: 120,
            ellipsis: true
        },
        {
            title: "Họ tên",
            dataIndex: "fullName",
            key: "fullName",
            width: 200,
            ellipsis: true,
            scopedSlots: {customRender: 'fullName'}
        },
        {
            title: "Số điện thoại",
            dataIndex: "phoneNumber",
            key: "phoneNumber",
            width: 150,
            ellipsis: true,
            scopedSlots: {customRender: 'phoneNumber'}
        },
        {
            title: "Email",
            dataIndex: "email",
            key: "email",
            width: 150,
            ellipsis: true,
            scopedSlots: {customRender: 'email'}
        },
        {
            title: "Trạng thái",
            dataIndex: "status",
            key: "status",
            scopedSlots: {customRender: 'status'},
            width: 150,
            ellipsis: true
        }
    ];

    created() {
        if (this.isAdmin) {
            this.columns = [
                ...this.columns,
                {
                    title: "Bưu cục",
                    dataIndex: "postOffice.name",
                    key: "postOfficeRowGuid",
                    width: 150,
                    ellipsis: true
                } as any
            ];
        }
        CustomerStore.updateCustomerParams(new CustomerParams());
        CustomerStore.listCustomer(CustomerStore.params);
    }

    get customers() {
        return CustomerStore.customers;
    }

    get pagination() {
        return {
            current: CustomerStore.meta.page,
            pageSize: CustomerStore.meta.limit,
            total: CustomerStore.meta.total,
            showTotal: (total: number) => `Tổng cộng ${total} khách hàng`,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: PAGE_SIZE_OPTIONS
        }
    }

    onChangePage(pagination: any) {
        CustomerStore.listCustomer({...CustomerStore.params, page: pagination.current, limit: pagination.pageSize});
    }
}
